import { isDevClient, isProdClient, YANDEX_METRICA_ID } from '@/constants'

const CURRENCY_CODE = 'RUB'

export const ECOMMERCE_ACTION_TYPE = {
  impressions: 'impressions',
  click: 'click',
  add: 'add',
  detail: 'detail',
  remove: 'remove',
  purchase: 'purchase',
}

export const makeProductFieldObject = sellerProduct => {
  return {
    id: `${sellerProduct.id}`,
    name: `${sellerProduct.product.name_ru || sellerProduct.product.name} ${sellerProduct.sort.name}`,
    brand: `${sellerProduct.brand?.name || 'Не указан'}`,
    price: sellerProduct.price,
    category: `${sellerProduct.group.name_ru || sellerProduct.group.name}`,
    discount: sellerProduct.discount,
    quantity: sellerProduct.quantity || 0,
  }
}

const pushToDataLayer = payload => {
  window.dataLayer.push({
    ecommerce: {
      currencyCode: CURRENCY_CODE,
      ...payload,
    },
  })
}

export const sendMetrics = async (goalID, params) => {
  if (!isProdClient) {
    if (!isDevClient) {
      console.log('DEV:sendMetrics:', [goalID, params])
    }

    return
  }

  if (typeof window !== 'undefined' && typeof window.ym !== 'undefined') {
    window.ym(YANDEX_METRICA_ID, 'reachGoal', goalID, params)
  }
}

export const pushEcommerce = async ({ actionType, products = [], actionField }) => {
  if (!isProdClient) {
    return
  }

  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return
  }

  try {
    if (actionType === ECOMMERCE_ACTION_TYPE.impressions) {
      pushToDataLayer({
        impressions: products.map(product => makeProductFieldObject(product)),
      })
    }

    if (actionType === ECOMMERCE_ACTION_TYPE.click) {
      pushToDataLayer({
        click: {
          products: products.map(product => makeProductFieldObject(product)),
        },
      })
      return
    }

    if (actionType === ECOMMERCE_ACTION_TYPE.detail) {
      pushToDataLayer({
        detail: {
          products: products.map(product => makeProductFieldObject(product)),
        },
      })
      return
    }

    if (actionType === ECOMMERCE_ACTION_TYPE.add) {
      pushToDataLayer({
        add: {
          products: products.map(product => makeProductFieldObject(product)),
        },
      })
      return
    }

    if (actionType === ECOMMERCE_ACTION_TYPE.remove) {
      pushToDataLayer({
        remove: {
          products: products.map(product => makeProductFieldObject(product)),
        },
      })
      return
    }

    if (actionType === ECOMMERCE_ACTION_TYPE.purchase) {
      pushToDataLayer({
        purchase: {
          actionField,
          products: products.map(product => makeProductFieldObject(product)),
        },
      })
    }
  } catch (e) {
    console.error(e)
  }
}

export const Metrics = {
  reportEvent: sendMetrics,
  pushEcommerce: pushEcommerce,
  reportProductsDeletedFromCart: products => {
    pushEcommerce({
      actionType: ECOMMERCE_ACTION_TYPE.remove,
      products,
    })

    for (let product of products) {
      sendMetrics(ECOMMERCE_ACTION_TYPE.remove, { product: makeProductFieldObject(product) })
    }
  },
  reportProductImpressions: products => {
    pushEcommerce({
      actionType: ECOMMERCE_ACTION_TYPE.impressions,
      products,
    })

    sendMetrics(ECOMMERCE_ACTION_TYPE.impressions, {
      products: products.map(makeProductFieldObject),
    })
  },
  reportProductClick: product => {
    pushEcommerce({ actionType: ECOMMERCE_ACTION_TYPE.click, products: [product] })
    sendMetrics(ECOMMERCE_ACTION_TYPE.click, {
      product: makeProductFieldObject(product),
    })
  },
}

export const reportOrderRevenue = order => {
  try {
    const revenue = (order.total_product_price_with_delivery - order.delivery_price) * 0.1

    sendMetrics('revenue_received', {
      order_id: order.id,
      revenue,
      currency: 'RUB',
      products: order.products.map(product => {
        return makeProductFieldObject({
          ...(product.original_product || product),
          quantity: product.weight,
          price: product.price,
        })
      }),
    })
  } catch (e) {
    console.error(e)
  }
}
